import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initOpenPanel, trackOpenPanelScreenView } from '../../analytics/openpanel';

/** Tracks SPA route changes for OpenPanel (initial HTML load alone is not enough). */
export function OpenPanelPageTracker(): null {
  const location = useLocation();

  useEffect(() => {
    initOpenPanel();
  }, []);

  useEffect(() => {
    trackOpenPanelScreenView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
}
